import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { ExtendCurrency } from 'src/enums'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface CurrencyErrorProps {
  currency: ExtendCurrency
}

const CurrencyError: React.FC<CurrencyErrorProps> = ({
  currency,
}): React.ReactElement => (
  <div
    css={css`
      ${getFontCss(
        12,
        styleConstants.colors.red,
        styleConstants.fontFamilies.regular,
      )};
    `}
  >
    <p
      css={css`
        font-family: ${styleConstants.fontFamilies.medium};
      `}
    >
      <Trns
        source={
          'You do not have any Accounts that support the requested currency ${currencyName}.'
        }
        expressions={{
          currencyName: `(${currency})`,
        }}
      />
    </p>
    <Trns
      source={
        "You can approve this request by selecting an account and entering a credit limit in that account's currency. You may want to follow up with the Recipient."
      }
    />
  </div>
)

export default CurrencyError
